import BaseRequest from './BaseRequest';
import { API_URL } from '../config/config';
import { sanitizeApiId, sanitizeApiCodAcervo, logSecurityEvent } from '../security/apiPathSecurity';

const ComentariosRequest = () => {
    return {
        buscarComentarios(codAcervo, cancelToken) {
            // Sanitize the codAcervo parameter to prevent SSRF attacks
            const sanitizedCod = sanitizeApiCodAcervo(codAcervo);
            if (!sanitizedCod) {
                logSecurityEvent('invalid_acervo_code_buscar', { providedCod: String(codAcervo) });
                return Promise.reject(new Error('Invalid acervo code provided'));
            }

            return BaseRequest.axiosInst.get(
                API_URL + '/comentarios/acervo/' + sanitizedCod,
                { headers: BaseRequest.publicHeaders, cancelToken },
            );
        },
        enviarComentario(codAcervo, comentario) {
            // Sanitize the codAcervo parameter to prevent SSRF attacks
            const sanitizedCod = sanitizeApiCodAcervo(codAcervo);
            if (!sanitizedCod) {
                logSecurityEvent('invalid_acervo_code_enviar', { providedCod: String(codAcervo) });
                return Promise.reject(new Error('Invalid acervo code provided'));
            }

            // Basic validation for comentario object
            if (!comentario || typeof comentario !== 'object') {
                logSecurityEvent('invalid_comentario_data', { providedData: String(comentario) });
                return Promise.reject(new Error('Invalid comentario data provided'));
            }

            return BaseRequest.axiosInst.post(
                API_URL + '/comentarios/acervo/' + sanitizedCod,
                comentario,
                { headers: BaseRequest.privateHeaders() },
            );
        },
        buscarQuantidadesComentariosAcervosUsuario() {
            return BaseRequest.axiosInst.get(
                API_URL + '/comentarios/usuario/acervos',
                { headers: BaseRequest.privateHeaders() },
            );
        },
        buscarComentariosPorAcervoUsuario(codAcervo) {
            // Sanitize the codAcervo parameter to prevent SSRF attacks
            const sanitizedCod = sanitizeApiCodAcervo(codAcervo);
            if (!sanitizedCod) {
                logSecurityEvent('invalid_acervo_code_usuario', { providedCod: String(codAcervo) });
                return Promise.reject(new Error('Invalid acervo code provided'));
            }

            return BaseRequest.axiosInst.get(
                API_URL + '/comentarios/usuario/acervo/' + sanitizedCod,
                { headers: BaseRequest.privateHeaders() },
            );
        },
        excluirComentarioAcervoUsuario(idComentario) {
            // Sanitize the idComentario parameter to prevent SSRF attacks
            const sanitizedId = sanitizeApiId(idComentario);
            if (!sanitizedId) {
                logSecurityEvent('invalid_comentario_id', { providedId: String(idComentario) });
                return Promise.reject(new Error('Invalid comentario ID provided'));
            }

            return BaseRequest.axiosInst.delete(
                API_URL + '/comentarios/usuario/' + sanitizedId,
                { headers: BaseRequest.privateHeaders() },
            );
        },
    };
};

export default ComentariosRequest();
